// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"1b1e0e00ee32cb96a61c","293":"6aebd64d6dbd302094d1","522":"ecae2b640b7c3162ec18"}[chunkId] + ".js";
};